const fontConfig = {
    title: '2rem',        // Tamanho da fonte para títulos
    subtitle: '1.5rem',   // Tamanho da fonte para subtítulos
    body: '1rem',         // Tamanho da fonte para o corpo do texto
    caption: '0.875rem',  // Tamanho da fonte para legendas ou textos menores
    small: '0.75rem',     // Tamanho da fonte para textos pequenos
    medium : '1.5rem',
    large: '2.5rem',      // Tamanho da fonte para textos grandes, como cabeçalhos principais
    extraLarge: '3rem',    // Tamanho da fonte para textos ainda maiores, 
    tableHeader : '1rem', 
    tableBody : '1rem',

};

export const Icones = {
    Editar : 'pi pi-pen-to-square', 
    Incluir : 'pi pi-plus', 
    Excluir : 'pi pi-times', 
    Fechar : 'pi pi-sign-out', 
    Pesquisar : 'pi pi-search', 
    Ativo : 'pi pi-check-circle', 
    Inativo : 'pi pi-ban', 
    Filtro : 'pi pi-search', 
    Data : 'pi pi-sync', 
    LimparFiltro : 'pi pi-filter-slash', 
    Dashboard : 'pi pi-chart-scatter', 
    Empresa : 'pi pi-shop', 
    Clientes : {
         Clientes : 'pi pi-address-book',
         ClienteCadastro : 'pi pi-user-plus', 
         Importacao : 'pi pi-upload', 
    },
    Collector :{
        Collecor : 'pi pi-objects-column', 
        LicencasCollector : 'pi pi-key', 
        Dcas : 'pi pi-share-alt'
    },
    Equipamentos :{
        Equipamentos : 'pi pi-print',
        Descobertas : 'pi pi-folder-plus', 
        Parque : 'pi pi-qrcode', 
        SemConexao : 'pi pi-minus-circle', 
        Desabilitados : 'pi pi-ban', 
        AlertasToner : 'pi pi-exclamation-triangle', 
        TrocasToner : 'pi pi-arrows-h', 
        TrocasPecas :'pi pi-sync',
        Manutenção : 'pi pi-wrench', 
        Atolamentos : 'pi pi-sort-alt-slash'
    }, 
    Computadores : 'pi pi-microchip', 
    Relatorios : {
        Relatorios : 'pi pi-file-word',
        RelatorioParque : 'pi pi-pen-to-square', 

    }

    
}

export default fontConfig;